import { signIn } from 'next-auth/react';

import Button from '@mui/material/Button';

import { AuthProvider } from '@/models';

export function ProviderButton({
  provider,
  callbackUrl,
}: Readonly<{ provider: AuthProvider; callbackUrl: string }>) {
  return (
    <Button
      variant="contained"
      startIcon={provider.icon}
      onClick={() => signIn(provider.name, { callbackUrl })}
      fullWidth
      size="large"
    >
      {provider.description}
    </Button>
  );
}
